/* eslint-disable prefer-const */
/* eslint-disable no-return-assign */
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button, TextField } from '@material-ui/core/'
import ReactHtmlParser from 'react-html-parser'
import moment from 'moment'
import apiAdmin from '../../../../../../../api/admin'
import { SendModal } from 'components/UI/'
import FilterSendEmail from '../FilterSendEmail'
import './index.scss'

const SendEmail = ({ setStep, template, setTemlate }) => {
  const [open, setOpen] = useState(false)
  const [time, setTime] = useState(new Date())
  const { user } = useSelector(({ session }) => session)
  const [addedFilter, setAddedFilter] = useState([])
  const [subject, setSubject] = useState('TellMee')
  const [count, setCount] = useState(0)
  const [timeSend, setTimeSend] = useState('')

  const sendTemplate = filters => {
    let newTime = new Date(timeSend)
    apiAdmin?.sendTemplate({
      accessKey: user?.accessKey,
      templateUuid: template?.uuid,
      subject: subject,
      from: 'info@tellme.place',
      filter: {
        ...filters,
        disableInformationEmails: { $not: true },
      },
      time: timeSend ? moment(newTime?.toUTCString())?.valueOf() : moment()?.valueOf(),
    }).then(({ data }) => console.error(data))
      .catch(error => console.error(error))
  }

  const countSend = () => {
    let newFilter = {}
    let newTime = new Date(timeSend)

    addedFilter?.map(item => {
      if (item?.value) {
        if (item?.inputType !== 'time') {
          if (item?.name === 'lastOnlineAt') {
            let date = new Date()
            date?.setDate(date?.getDate() - +item?.value)
            return newFilter = { ...newFilter, [item?.name]: { [item?.index]: date?.toISOString() } }
          } else {
            return newFilter = { ...newFilter, [item?.name]: { [item?.index]: item?.value } }
          }
        }
      }
    })
    apiAdmin?.getSendCountUsers({
      accessKey: user?.accessKey,
      templateUuid: template?.uuid,
      subject: subject,
      from: 'info@tellme.place',
      filter: {
        ...newFilter,
        disableInformationEmails: { $not: true },
      },
      time: timeSend ? moment(newTime?.toUTCString())?.valueOf() : moment()?.valueOf(),
    }).then(({ data }) => setCount(data?.count))
      .catch(error => console.error(error))

    sendTemplate(newFilter)
  }

  return (
    <>
      <SendModal open={open} setOpen={setOpen} time={time} setTime={setTime} />
      <Grid className='wrapperSendEmail'>
        <Button
          variant='contained'
          color='primary'
          className='btnBack'
          onClick={() => {
            setStep(0)
            setTemlate({})
          }}
        >
          BACK
        </Button>
        <span className='countSend'>
          {count}
        </span>
        <FilterSendEmail setTimeSend={setTimeSend} setAddedFilter={setAddedFilter} addedFilter={addedFilter} />
        <TextField value={subject} onChange={e => setSubject(e?.target?.value)} className='emaillInput' id='outlined-basic' variant='outlined' placeholder='Theme' />
        <Grid>
          {ReactHtmlParser(template?.html)}
        </Grid>
        <Button variant='contained' color='primary' className='btnSend' onClick={countSend}>SEND</Button>
      </Grid>
    </>
  )
}

export default SendEmail
